const EmailLayout = () => import('@/modules/email/view/Email.layout.vue');
const EmailInboxView = () =>
  import('@/modules/email/view/EmailInbox/EmailInbox.vue');
const EmailArchivedView = () =>
  import('@/modules/email/view/EmailArchived/EmailArchived.vue');
const EmailDraftsView = () =>
  import('@/modules/email/view/EmailDrafts/EmailDrafts.vue');
const EmailSentView = () =>
  import('@/modules/email/view/EmailSent/EmailSent.vue');
const EmailBinView = () => import('@/modules/email/view/EmailBin/EmailBin.vue');
const EmailSend = () => import('@/modules/email/view/EmailSend/EmailSend.vue');
const EmailReading = () =>
  import('@/modules/email/view/EmailReading/EmailReading.vue');
const EmailSpam = () => import('@/modules/email/view/EmailSpam/EmailSpam.vue');
const EmailSettingsLayout = () =>
  import('@/modules/email/view/EmailSettings/EmailSettingsLayout.vue');
const EmailGeneralSettings = () =>
  import(
    '@/modules/email/view/EmailSettings/GeneralSettings/GeneralSettings.vue'
  );
const PreferencesSettings = () =>
  import(
    '@/modules/email/view/EmailSettings/PreferencesSettings/PreferencesSettings.vue'
  );

export default [
  {
    path: 'email',
    name: 'email',
    redirect: { name: 'email.inbox' },
    component: EmailLayout,
    children: [
      {
        path: 'send',
        name: 'email.send',
        component: EmailSend,
        meta: {
          emailCredentials: true,
        },
      },
      {
        path: 'inbox',
        name: 'email.inbox',
        component: EmailInboxView,
        meta: {
          emailCredentials: true,
        },
      },
      {
        path: 'archived',
        name: 'email.archived',
        component: EmailArchivedView,
        meta: {
          emailCredentials: true,
        },
      },
      {
        path: 'spam',
        name: 'email.spam',
        component: EmailSpam,
        meta: {
          emailCredentials: true,
        },
      },
      {
        path: 'sent',
        name: 'email.sent',
        component: EmailSentView,
        meta: {
          emailCredentials: true,
        },
      },
      {
        path: 'drafts',
        name: 'email.drafts',
        component: EmailDraftsView,
        meta: {
          emailCredentials: true,
        },
      },
      {
        path: 'bin',
        name: 'email.bin',
        component: EmailBinView,
        meta: {
          emailCredentials: true,
        },
      },
      {
        path: 'reading/:id',
        name: 'email.reading',
        component: EmailReading,
        meta: {
          emailCredentials: true,
        },
      },
      {
        path: 'settings',
        component: EmailSettingsLayout,
        children: [
          {
            path: 'general',
            name: 'email.settings',
            component: EmailGeneralSettings,
          },
          {
            path: 'preferences',
            name: 'settings.preferences',
            component: PreferencesSettings,
          },
        ],
      },
    ],
  },
];
